var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 26,
    rx: 23.5,
    ry: 24,
    fill: "#FFD075"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5C14 19.5 16.5 20 21.75 20.125",
    stroke: "#FEFCFB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.5C18 16 19 18 21.75 20.5",
    stroke: "#FEFCFB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 11.125C23.5002 15 23.5003 17 22.1252 20.125",
    stroke: "#FEFCFB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 10.5C28.5 16 27 17.5 22.25 20.125",
    stroke: "#FEFCFB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 11C32 18 29.5 19 22 20.5",
    stroke: "#FEFCFB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5C11 22 15 22.5 22.25 20.4201",
    stroke: "#FEFCFB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20C24.5 27 25 29.5 25.5 40",
    stroke: "#FEFCFB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1173 35.5H25.5C26.3284 35.5 27 36.1716 27 37V44.2085C27 44.9218 26.4218 45.5 25.7085 45.5C25.0504 45.5 24.4975 45.0052 24.4248 44.3511L23.6264 37.1656C23.5277 36.2771 24.2232 35.5 25.1173 35.5Z",
    fill: "#FEFCFB",
    stroke: "#FEFCFB",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.5C25 29 25 30 25.5 40",
    stroke: "#FEFCFB",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.698dc553372be9b88445684ba200c937.svg";
export { ForwardRef as ReactComponent };